import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Pagination } from 'src/components';
import AppBodyLayout from '../../components/Common/Layouts/appBodyLayout';
import CollectionItem from './CollectionItem';
import { useCollections } from './useCollections';
import defaultClasses from './collections.module.css';
import { getGroup } from '../../Utils/utils';
import { Meta, StoreTitle } from '@magento/venia-ui/lib/components/Head';

var Colletions = function Colletions() {
  // const { pathname, search } = useLocation();
  // const searchParams = new URLSearchParams(search);
  // const page = searchParams.get('page');
  // const pageS = searchParams.get('pageSize');
  // const filterS = searchParams.get('filterId');
  // const [currentPage, setCurrentPageState] = useState(page ? Number(page) : 1);
  // const [filterId, setFilterId] = useState(filterS ? Number(filterS) : 1);
  // const [pageSize, setPageSize] = useState(pageS ? Number(pageS) : 15);
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      collectionItems = _useState2[0],
      setCollectionItems = _useState2[1];

  var history = useHistory();

  var _React$useState = React.useState(function () {
    if (history.action !== 'POP') {
      return null;
    }

    var persistedId = sessionStorage.getItem('scroll-position-product-id-marker');
    sessionStorage.removeItem('scroll-position-product-id-marker');
    return persistedId ? persistedId : null;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      productMarkerId = _React$useState2[0];

  var _useCollections = useCollections({// pageSize,
    // currentPage,
    // filterId,
  }),
      loading = _useCollections.loading,
      error = _useCollections.error,
      collections = _useCollections.collections,
      category = _useCollections.category;

  useEffect(function () {
    if (collections) {
      setCollectionItems(collections.map(function (item) {
        return getGroup(item);
      }));
    }
  }, [collections]); // const setCurrentPage = page => {
  //     setCurrentPageState(page);
  //     history.push({
  //         pathname,
  //         search: `?page=${page}&pageSize=${pageSize}&filterId=${filterId}`
  //     });
  // };
  // const setCurrentPageSize = pageSize => {
  //     setCurrentPageState(1);
  //     setPageSize(pageSize);
  //     history.push({ pathname, search: `?page=${1}&pageSize=${pageSize}&filterId=${filterId}` });
  // };
  // const viewAll = () => {
  //     setPageSize(totalCollections);
  //     setCurrentPageState(1);
  // };
  // const pageControl = useMemo(
  //     () => ({
  //         currentPage,
  //         viewAll: viewAll,
  //         setPage: setCurrentPage,
  //         setPageSize: setCurrentPageSize,
  //         totalPages
  //     }),
  //     [currentPage, totalPages]
  // );
  // const handleFilter = useCallback(
  //     filter => {
  //         if (filter === filterId) {
  //             setFilterId(null);
  //         } else {
  //             setFilterId(filter);
  //         }
  //         setCurrentPageState(1);
  //         setPageSize(15);
  //         history.push({ pathname, search: `?page=${1}&pageSize=${15}&filterId=${filter}` });
  //     },
  //     [filterId]
  // );
  // const handleChangeFilter = useCallback(filterId => {
  //     handleFilter(filterId);
  // }, []);

  var persistScrollPosition = function persistScrollPosition(id) {
    sessionStorage.setItem('scroll-position-product-id-marker', id);
  };

  var collectionsData = collectionItems === null || collectionItems === void 0 ? void 0 : collectionItems.map(function (item, index) {
    return React.createElement(CollectionItem, {
      key: index,
      item: item,
      onSelect: persistScrollPosition,
      restorationValue: Number(productMarkerId) === item.collections_id
    });
  });
  return React.createElement(React.Fragment, null, React.createElement(AppBodyLayout, null, React.createElement(StoreTitle, null, category === null || category === void 0 ? void 0 : category.name), React.createElement(Meta, {
    name: "description",
    content: category !== null && category !== void 0 && category.meta_description ? category === null || category === void 0 ? void 0 : category.meta_description : ''
  }), React.createElement(Meta, {
    name: "title",
    content: category !== null && category !== void 0 && category.meta_title ? category === null || category === void 0 ? void 0 : category.meta_title : category === null || category === void 0 ? void 0 : category.name
  }), React.createElement(Meta, {
    name: "keywords",
    content: category !== null && category !== void 0 && category.meta_keywords ? category === null || category === void 0 ? void 0 : category.meta_keywords : ''
  }), React.createElement("div", {
    className: defaultClasses.breadcrumbWrapper
  }, React.createElement(Link, {
    className: "text-xs sm_text-sm leading-2 underline",
    to: "/",
    "aria-label": "Go to Home page"
  }, "Home"), React.createElement("span", {
    className: "mx-1 leading-2"
  }, "|"), React.createElement("p", {
    className: "text-xs sm_text-sm"
  }, "Collections")), React.createElement("h1", {
    className: "h3 ".concat(defaultClasses.collectionsTitle)
  }, "Collections"), React.createElement("div", {
    className: defaultClasses.collectionsDataWrapper
  }, collectionsData ? collectionsData : React.createElement("div", null, "No Collections Found!"))));
};

export default Colletions;